export default {"src":"/_next/static/media/BooksSpread.e0d70dac.svg","height":130,"width":360,"blurWidth":0,"blurHeight":0};